export default {
  pay: "Pay",
  acceptTermsAndConditions: "Accept Terms and Conditions",
  selectYourCard: "SELECT YOUR CARD",
  yourOrder: "Your Order",
  generalPlaceHolderNotes:
    "You can remove ingredients, you cannot add or change",
  placeholderNotesDrinks: "Comments ...",
  placeholderNotesFood: "Comments ...",
  total: "TOTAL:",
  totalToPay: "Total to pay:",
  paymentConfirmation: "Payment confirmation",
  paymentRequest: "You have requested the payment of:",
  payCash: "Pay Cash",
  yourOrderIsInProgress: "Your order is in progress,",
  itWillReachYou: "it will reach you",
  desk: "desk",
  paymentMethod: "PAYMENT METHOD",
  dataphone: "Dataphone",
  smartphone: "Smartphone",
  howDoYouWantToPay: "How do you want to pay?",
  creditOrDebitCard: "Credit or debit card",
  missingPay: "Missing Pay:",
  petitionRejected: "Petition rejected",
  redirectingToThePaymentprocess: "Redirecting to the payment process",
  addNewCard: "Add new card",
  paymentMade: "Payment Made",
  receiptOfYourPaymentTo: "Receipt of your payment to"
};
